import React, {useContext} from "react";
import {Container, Nav, Navbar} from "react-bootstrap";
import "./styles.css";
import {Link} from "react-router-dom";
import {AppStateContext} from "../../App";
import Cart from "../Cart/Cart";

function NavBar() {

    const {loggedInUser} = useContext(AppStateContext);

    return (
        <Container className="app-navbar">
            <Navbar bg="light" expand="md" className="px-0">
            <Navbar.Brand className="d-flex align-items-center justify-content-between app-navbar-brand">
                <Link to={"/home"}>
                    <img
                        alt="spectrum logo"
                        src="/assets/images/logo_.png"
                        width="340"
                        height={59}
                        className="d-inline-block align-top img-fluid"
                    />{' '}
                </Link>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            </Navbar.Brand>

            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                <Nav>
                    {/* <Nav.Link as={Link} to="/about">About Sage Spectrum</Nav.Link> */}
                    {/* <Nav.Link as={Link} to="/package-detail">Publish with us</Nav.Link> */}
                    {/* <Nav.Link as={Link} to={
                        {
                            pathname: "/books",
                            search: "?access_types=open_access",
                            hash: "",
                            key: "open-access-nav-link"
                        }
                    }>Open access</Nav.Link> */}
                    {/* <Nav.Link href="/books?access_types=non_open_access">Buy here</Nav.Link>
                    {
                        (!loggedInUser || !loggedInUser.author) && <Nav.Link href="/contact-us">Contact us</Nav.Link>
                    } */}
                    <Nav.Link href="/contact-us">Contact us</Nav.Link>
                    {/* {
                        (process.env.REACT_APP_PHASE_EC === "1") && <Cart/>
                    } */}
                </Nav>
            </Navbar.Collapse>
        </Navbar></Container>
    );
}

export default NavBar;
